module.exports = __webpack_public_path__ + "img/selelctor.144f8700.svg";